import { useMemo } from 'react';
import { BRAND_CATEGORY_FILTER_OPTIONS } from 'lib/networking/endpoints';
import { removeUndefinedAndNull } from 'lib/utils/objectUtils';
import useGet from 'lib/hooks/useGet';

function useBrandCategoryFilterOptions(
  brandId,
  manufacturerId,
  vendorId,
  l1CategoryId,
  l2CategoryId,
  l3CategoryId,
) {
  const { data, loading } = useGet(
    BRAND_CATEGORY_FILTER_OPTIONS,
    removeUndefinedAndNull({
      brand_id: brandId,
      manufacturer_id: manufacturerId,
      vendor_id: vendorId,
      l1_category_id: l1CategoryId,
      l2_category_id: l2CategoryId,
      l3_category_id: l3CategoryId,
    }),
    !brandId,
  );

  const options = useMemo(() => {
    const mapOption = category => ({
      label: category.category_name,
      value: category.id,
      id: category.id,
    });
    return {
      l1Options: data?.l1_categories?.map(mapOption) || [],
      l2Options: data?.l2_categories?.map(mapOption) || [],
      l3Options: data?.l3_categories?.map(mapOption) || [],
      l4Options: data?.l4_categories?.map(mapOption) || [],
    };
  }, [data]);

  return { options, loading };
}

export default useBrandCategoryFilterOptions;
